import React, { useState } from 'react';
import { Avatar, Button, Modal, Row, Space, Tooltip, Typography } from 'antd';
import { CloudDownloadOutlined, DownloadOutlined, InfoCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useAxios } from '../../service/useAxios';
import { downloadBlob } from '../common-constants';
import moment from 'moment';
const { Text } = Typography;

export const useExcelExporter = (entityName, selectedRowKeys) => {
  const { t } = useTranslation(); 
  const [exportModalVisible, setExportModalVisible] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const axiosInstance = useAxios();

  const onExport = () => {
    setExportModalVisible(true);
  }

  const onExportSelected = () => {
    if (selectedRowKeys.length > 0) {
      exportData({
        idList: selectedRowKeys.join(',')
      });
    }
  }

  const onExportAll = () => {
    exportData({
      all: true
    });
  }

  const exportData = (params) => {
    setExportLoading(true);
    axiosInstance.request({
      url: '/api/' + entityName + '/excel',
      params: params,
      method: 'GET',
      responseType: 'arraybuffer',
    }).then((response) => {
      downloadBlob(response.data, entityName + '_' + moment().format('DD_MM_YYYY-HH_mm_ss') + '.xlsx')
    }).finally(() => setExportLoading(false));
  }

  const excelExportModal = (
    <Modal
      title={t('common.exportToExcel')}    
      open={exportModalVisible}
      footer={null}
      onCancel={() => setExportModalVisible(false)}
    >
      <Row justify='center'>
        <Avatar
          size={96}
          icon={exportLoading ? <SyncOutlined spin /> : <CloudDownloadOutlined />}
        />
      </Row>
      <Row justify='center' style={{ marginTop: '2em' }}>
        <Space>
          <Button
            disabled={exportLoading}
            onClick={onExportAll}
            icon={<DownloadOutlined />}
          >
            {t('common.allItems')}             
          </Button>
          <Button
            disabled={selectedRowKeys.length <= 0 || exportLoading}
            onClick={onExportSelected}
            icon={<DownloadOutlined />}
          >
            {t('common.selectedItems')}         
          </Button>
        </Space>
      </Row>
      {exportLoading &&
        <Row justify='center' style={{ marginTop: '1em' }}>
          <Text type="secondary">
            {t('common.filePreparing')}         
          </Text>
          <Text type="secondary">
            {t('common.doNotClosePage')}      
          </Text>
          <Text type="secondary">
            {t('common.mightTakeFewMinutes')} {" "}  
            <Tooltip title={t('common.smallerSetHint')}>  
              <InfoCircleOutlined />
            </Tooltip>
          </Text>
        </Row>
      }
    </Modal>
  );

  return {
    excelExportModal,
    onExport,
  }
};